import {
  CheckAvatarGenerationQuery,
  CheckAvatarGenerationQueryVariables,
  ClearAvatarsMutation,
  ClearAvatarsMutationVariables,
  SaveAvatarMutation,
  SaveAvatarMutationVariables,
  StartAvatarGenerationMutation,
  StartAvatarGenerationMutationVariables,
} from "@outschool/gql-frontend-generated";
import { gql, useLazyQuery, useMutation } from "@outschool/ui-apollo";

const SAVE_AVATAR_MUTATION = gql`
  mutation SaveAvatar(
    $imageCdnUrl: String!
    $name: String!
    $description: String!
    $creatureType: String!
  ) {
    saveAvatar(
      imageCdnUrl: $imageCdnUrl
      name: $name
      description: $description
      creatureType: $creatureType
    ) {
      uid
      learnerUid
      attachmentUid
      description
      animals
      creatureType
      createdAt
    }
  }
`;

export function useSaveAvatarMutation() {
  return useMutation<SaveAvatarMutation, SaveAvatarMutationVariables>(
    SAVE_AVATAR_MUTATION,
  );
}

const CLEAR_AVATARS_MUTATION = gql`
  mutation ClearAvatars {
    clearAvatars
  }
`;

export function useClearAvatarsMutation() {
  return useMutation<ClearAvatarsMutation, ClearAvatarsMutationVariables>(
    CLEAR_AVATARS_MUTATION,
  );
}

// Client-side polling hooks
const START_AVATAR_GENERATION_MUTATION = gql`
  mutation StartAvatarGeneration(
    $creatureType: String!
    $style: String!
    $background: String!
  ) {
    startAvatarGeneration(
      creatureType: $creatureType
      style: $style
      background: $background
    ) {
      generationId
      name
      description
    }
  }
`;

export function useStartAvatarGenerationMutation() {
  return useMutation<
    StartAvatarGenerationMutation,
    StartAvatarGenerationMutationVariables
  >(START_AVATAR_GENERATION_MUTATION);
}

const CHECK_AVATAR_GENERATION_QUERY = gql`
  query CheckAvatarGeneration(
    $generationId: String!
    $avatarName: String!
    $creatureType: String!
  ) {
    checkAvatarGeneration(
      generationId: $generationId
      avatarName: $avatarName
      creatureType: $creatureType
    ) {
      status
      imageUrl
    }
  }
`;

export const POLLING_INTERVAL_MS = 2000;

export function useCheckAvatarGenerationQuery() {
  return useLazyQuery<
    CheckAvatarGenerationQuery,
    CheckAvatarGenerationQueryVariables
  >(CHECK_AVATAR_GENERATION_QUERY, {
    fetchPolicy: "network-only",
  });
}
